import React from "react";
import HeroGeocercasDemo from "@/components/marketing/HeroGeocercasDemo.jsx";

export default function DemoGeocercas() {
  return (
    <main className="min-h-screen bg-slate-50 px-4 py-8 sm:px-6 lg:px-8">
      <div className="mx-auto w-full max-w-7xl">
        <HeroGeocercasDemo />
      </div>
    </main>
  );
}
